import { type RefObject, useEffect } from 'react';

interface UseClickOutsideArgs {
  el: RefObject<HTMLElement | null>;
  excludeEls?: RefObject<HTMLElement | null>[];
  onClickOutside: () => unknown;
}

export const useClickOutside = ({ el, excludeEls = [], onClickOutside }: UseClickOutsideArgs) => {
  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      if (
        !el.current ||
        el.current.contains(event.target as Node) ||
        excludeEls.find((e) => e.current && e.current.contains(event.target as Node))
      ) {
        return;
      }
      onClickOutside();
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
};
